var map = {
	"./bank-alandsbanken.svg": 7378,
	"./bank-danskebank.svg": 6370,
	"./bank-handelsbanken.svg": 4464,
	"./bank-nordea.svg": 7257,
	"./bank-omasp.svg": 7668,
	"./bank-op.svg": 5129,
	"./bank-poppankki.svg": 5993,
	"./bank-saastopankki.svg": 6651,
	"./bank-spankki.svg": 1451,
	"./flag-dk.svg": 3087,
	"./flag-fi.svg": 7723,
	"./flag-no.svg": 2429,
	"./flag-se.svg": 1460,
	"./icon-arrow.svg": 1306,
	"./icon-back.svg": 2790,
	"./icon-card.svg": 1445,
	"./icon-checkmark.svg": 3334,
	"./icon-close.svg": 7545,
	"./icon-collectorbank-credit-warning.svg": 7387,
	"./icon-ctrl-q.svg": 5698,
	"./icon-date.svg": 6875,
	"./icon-edit.svg": 2291,
	"./icon-email.svg": 9021,
	"./icon-esc.svg": 3890,
	"./icon-info.svg": 2007,
	"./icon-input-checkmark.svg": 7649,
	"./icon-input-error.svg": 8652,
	"./icon-lock.svg": 6918,
	"./icon-phone-shake.svg": 9528,
	"./icon-phone-verified.svg": 9642,
	"./icon-phone.svg": 2165,
	"./icon-question.svg": 2663,
	"./icon-security-code.svg": 501,
	"./icon-user-saved.svg": 6820,
	"./icon-warning-message.svg": 8311,
	"./logo-worldline.svg": 9689,
	"./paymentcard-amex.svg": 8049,
	"./paymentcard-dankort.svg": 3605,
	"./paymentcard-diners.svg": 9615,
	"./paymentcard-discover.svg": 6049,
	"./paymentcard-fbf.svg": 6730,
	"./paymentcard-jcb.svg": 1769,
	"./paymentcard-maestro.svg": 8131,
	"./paymentcard-mastercard.svg": 2984,
	"./paymentcard-visa.svg": 4859,
	"./paymenttype-applepay.svg": 3812,
	"./paymenttype-ekspresbank.svg": 9257,
	"./paymenttype-googlepay.svg": 5355,
	"./paymenttype-mobilepay.svg": 9634,
	"./paymenttype-nordeaepaymentfi.svg": 4277,
	"./paymenttype-swish.svg": 5832,
	"./paymenttype-viabill.svg": 6293,
	"./paymenttype-vipps.svg": 3936,
	"./paymenttype-walley.svg": 1152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 450;